export const getElementsOfType = (elements, ElementType) => {
    if (Array.isArray(elements)) {
        return elements.filter((child) => child.type === ElementType);
    }
    if (elements.type === ElementType) {
        return [elements];
    }
    return [];
};
